const updateUser = async (db, email, payload) => {
  await db.collection('users').doc(email).set(payload, { merge: true })
}

module.exports = updateUser